import { data } from '../../svg/SuccessConfirmation/data';
import { makeIcon } from '../makeIcon';

export const SuccessConfirmation = makeIcon(data, 'success_confirmation', 'SuccessConfirmation');

export default SuccessConfirmation;
